export default __webpack_public_path__ + "static/1-af8b370122d5c208f5515a0d6b982f13.png";